import { createRef } from 'react';
import { create } from 'zustand';
// ----------------------------------------------------------------------
export const usePlayerStore = create()((set) => ({
    available: false,
    buffering: false,
    captions: 'undefined',
    chapter: undefined,
    duration: 0,
    ended: false,
    error: false,
    fullscreen: false,
    loaded: 0,
    locale: 'en',
    muted: false,
    played: 0,
    player: createRef(),
    playerHover: false,
    playing: false,
    sliderHoverPosition: 0,
    sliderHover: false,
    seeking: false,
    url: undefined,
    volume: 0.9,
    volumeHover: false,
    setAvailable: (available) => set(() => ({ available })),
    setBuffering: (buffering) => set(() => ({ buffering })),
    setCaptions: (captions) => set(() => ({ captions })),
    setChapter: (chapter) => set(() => ({ chapter })),
    setDuration: (duration) => set(() => ({ duration })),
    setEnded: () => set((state) => ({ ended: !state.ended })),
    setError: () => set((state) => ({ error: !state.error })),
    setFullscreen: () => set((state) => ({ fullscreen: !state.fullscreen })),
    setLoaded: (loaded) => set(() => ({ loaded })),
    setLocale: (locale) => set(() => ({ locale })),
    setMuted: () => set((state) => ({ muted: !state.muted })),
    setPlayed: (played) => set(() => ({ played })),
    setPlayer: (player) => set(() => ({ player })),
    setPlayerHover: (playerHover) => set(() => ({ playerHover })),
    setPlaying: (playing) => set(() => ({ playing })),
    setSliderHover: (sliderHover) => set(() => ({ sliderHover })),
    setSliderHoverPosition: (sliderHoverPosition) => set(() => ({ sliderHoverPosition })),
    setUrl: (url) => set(() => ({ url })),
    setVolume: (volume) => set(() => ({ volume })),
    setVolumeHover: () => set((state) => ({ volumeHover: !state.volumeHover })),
    togglePlaying: () => set((state) => ({ playing: !state.playing })),
    toggleSeeking: () => set((state) => ({ playing: !state.seeking })),
}));
